import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__letter-filled",
  "use": "icon__letter-filled-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol viewBox=\"0 0 22 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__letter-filled\"><title>Shape</title><path d=\"M0 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zm18.883 4.066l-7.75 4.851a.25.25 0 0 1-.266 0l-7.75-4.851A.25.25 0 0 1 3 4.854V3.45a.25.25 0 0 1 .383-.211l7.484 4.685a.25.25 0 0 0 .266 0l7.484-4.685A.25.25 0 0 1 19 3.45v1.403a.25.25 0 0 1-.117.212z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol